import React from "react";

import WithSuspense from "./components/WithSuspense";

const Main = React.lazy(() => import("./components/Main"));

const App = () => {
  return (
    <WithSuspense>
      <Main />
    </WithSuspense>
  );
};

export default App;
